import config from '../../config';
import {AirtablePromotionItem} from '../../models/airtable';

export const isSummerCashGrabCompetition = (comp: AirtablePromotionItem) =>
  comp?.activationUrlName === config.SUMMER_CASH_GRAB_COMPETITION_NAME;
